import MuiBadge, { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';

export type BadgeProps = MuiBadgeProps;

export const Badge = (props: BadgeProps) => {
  return <MuiBadge {...props} />;
};
